import type { Application } from '../../../graphql/applications/types'

// What the form edits, as the strings and flags the inputs hold
export interface ApplicationValues {
  name: string
  onesignalId: string
  onesignalKey: string
  livestream: string
  accesses: string[]
  observations: string
  minVersion: string
  latestVersion: string
  storeUrlAndroid: string
  storeUrlIos: string
  apiBaseUrl: string
  imageBaseUrl: string
}

// The inputs that can carry an error, in form order: the first one with an error gets the focus
export const FIELD_IDS = {
  name: 'app-name',
  minVersion: 'app-min-version',
  latestVersion: 'app-latest-version',
  storeUrlAndroid: 'app-store-url-android',
  storeUrlIos: 'app-store-url-ios',
  apiBaseUrl: 'app-api-base-url',
  imageBaseUrl: 'app-image-base-url',
} as const

export type ErrorField = keyof typeof FIELD_IDS
export type ApplicationErrors = Partial<Record<ErrorField, string>>

export function valuesFromApplication(application?: Application): ApplicationValues {
  return {
    name: application?.name ?? '',
    onesignalId: application?.onesignal_id ?? '',
    onesignalKey: application?.onesignal_rest_api_key ?? '',
    livestream: application?.livestream_preset ?? '',
    accesses: application?.accesses ?? [],
    observations: application?.observations ?? '',
    minVersion: application?.min_version ?? '',
    latestVersion: application?.latest_version ?? '',
    storeUrlAndroid: application?.store_url_android ?? '',
    storeUrlIos: application?.store_url_ios ?? '',
    apiBaseUrl: application?.api_base_url ?? '',
    imageBaseUrl: application?.image_base_url ?? '',
  }
}

// What every tab organism receives
export interface ApplicationTabProps {
  values: ApplicationValues
  errors: ApplicationErrors
  onChange: <K extends keyof ApplicationValues>(key: K, value: ApplicationValues[K]) => void
  skeleton?: boolean
}
